module.exports = __webpack_public_path__ + "img/zyk.27f4b4d0.png";